export default {"src":"/_next/static/media/icon-first-name-basis.3921edb4.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};